import React, { useState } from "react";
import { Globe } from "lucide-react";
import { getLang, setLang } from "../lib/i18n";

export const LangToggle = ({ className = "" }) => {
  const [lang, set] = useState(getLang());
  const toggle = () => {
    const next = lang === "en" ? "es" : "en";
    set(next);
    setLang(next);
  };
  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="lang-toggle"
      aria-label={lang === "en" ? "Cambiar a Español" : "Switch to English"}
      className={`inline-flex items-center gap-1.5 rounded-full border border-purple-500/40 bg-purple-600/10 hover:border-[#E5C56F]/60 hover:text-[#FFE9A8] px-3 py-1.5 text-[10px] uppercase tracking-[0.28em] text-purple-200 transition-colors duration-300 ${className}`}
    >
      <Globe size={11} strokeWidth={1.8} />
      {lang === "en" ? "ES" : "EN"}
    </button>
  );
};

export default LangToggle;
